/* Performance TV overlay — opens from the tracker header. Rendering lives in jarvis/PerformanceTV. */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PerformanceTV from './jarvis/PerformanceTV';

export default function PerformanceCommandCentre({ open, onClose }) {
  const { token } = useAuth();
  if (!open) return null;
  return <PerformanceTV token={token} onExit={onClose} />;
}
